import { Addendum } from "@/core/types";
import dayjs from "@/lib/helpers/dayjs";

const DATE_FORMAT = "MM/DD/YYYY hh:mma";

type AddendumActionDate = { dateTime: string; display: string };

const parseAddendumDate = (date: Nullable<string>): AddendumActionDate | null => {
  if (!date) return null;
  const parsed = dayjs(date);

  return { dateTime: parsed.toISOString(), display: parsed.format(DATE_FORMAT) };
};

export const getAddendumActionDate = (addendum: Addendum): AddendumActionDate | null => {
  switch (addendum.addendum_state) {
    case "pending":

    case "resubmitted":
      return parseAddendumDate(addendum.created_at);

    case "complete":
      return parseAddendumDate(addendum.completed_at);

    default:
      return null;
  }
};
